// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.0
//   protoc               v5.28.0
// source: io/instruct_plugin_input.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Instruction } from "../plugin/instruction";

/** [Internal] Input to a instruct plugin request to Hank. */
export interface InstructPluginInput {
  /** The the instruction to send to a Hank plugin. */
  instruction: Instruction | undefined;
}

function createBaseInstructPluginInput(): InstructPluginInput {
  return { instruction: undefined };
}

export const InstructPluginInput: MessageFns<InstructPluginInput> = {
  encode(message: InstructPluginInput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.instruction !== undefined) {
      Instruction.encode(message.instruction, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InstructPluginInput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInstructPluginInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.instruction = Instruction.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InstructPluginInput {
    return { instruction: isSet(object.instruction) ? Instruction.fromJSON(object.instruction) : undefined };
  },

  toJSON(message: InstructPluginInput): unknown {
    const obj: any = {};
    if (message.instruction !== undefined) {
      obj.instruction = Instruction.toJSON(message.instruction);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InstructPluginInput>, I>>(base?: I): InstructPluginInput {
    return InstructPluginInput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InstructPluginInput>, I>>(object: I): InstructPluginInput {
    const message = createBaseInstructPluginInput();
    message.instruction = (object.instruction !== undefined && object.instruction !== null)
      ? Instruction.fromPartial(object.instruction)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
